import { useGoogleLogin } from '@react-oauth/google';
import { useDispatch, useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import PropTypes from 'prop-types';

import { authService } from '../../services/napoleon';
import { googleLogoIcon } from '../../assets/images/icons';
import {
  updateAuthByGoogle,
  updateRegisterData,
  updateRegisterStep,
} from '../../redux/actions/userActions';
import { REGISTER_STEPS, STEP_ORDER } from '../../constants/registerSteps';
import useToastActions from '../../redux/actions/useToastActions';
import useAuth from '../../common/hooks/useAuth';
import styles from './styles';

const signInInfo = REGISTER_STEPS.SIGN_IN_INFO;
const userInfo = REGISTER_STEPS.USER_INFO;
const errorMsg = 'Login com Google falhou';

export default function GoogleLoginButton({
  focusCreateAccountTab,
  isLoading,
  setLoading,
  labelButton,
}) {
  const { login } = useAuth(focusCreateAccountTab);
  const { error } = useToastActions();
  const dispatch = useDispatch();
  const { steps } = useSelector((state) => state.registerStepReducer);
  const signInInfoForm = steps[signInInfo];
  const userInfoForm = steps[userInfo];

  function updateRegisterStepsFormsData(email, name) {
    signInInfoForm.email = email;
    userInfoForm.name = name;

    dispatch(updateRegisterData(signInInfo, signInInfoForm));
    dispatch(updateRegisterData(userInfo, userInfoForm));

    dispatch(
      updateAuthByGoogle({
        email,
        name,
        authProvider: 'google',
        authGoogle: true,
      }),
    );
  }

  const handleLogin = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async ({ code }) => {
      try {
        const res = await authService.googleLogin({ code });

        const { auth, token, googleUser } = res.data;

        if (auth && token) {
          const { user } = jwtDecode(token);
          updateRegisterStepsFormsData(user.email, user.name);
          login(token);
        } else if (googleUser) {
          updateRegisterStepsFormsData(googleUser.email, googleUser.name);
          setLoading(false);
          if (focusCreateAccountTab) {
            focusCreateAccountTab();
          }

          dispatch(updateRegisterStep(STEP_ORDER.indexOf(REGISTER_STEPS.USER_INFO)));
        } else {
          error(errorMsg);
        }
      } catch (err) {
        error(errorMsg);
      } finally {
        setLoading(false);
      }
    },
    onError: () => {
      error(errorMsg);
      setLoading(false);
    },
    onNonOAuthError: () => setLoading(false),
  });

  return (
    <button
      onClick={() => {
        setLoading(true);
        handleLogin();
      }}
      style={styles.button}
      disabled={isLoading}
    >
      <img src={googleLogoIcon} alt="Google logo" style={styles.icon} />
      {labelButton}
    </button>
  );
}

GoogleLoginButton.propTypes = {
  focusCreateAccountTab: PropTypes.func,
  isLoading: PropTypes.bool,
  setLoading: PropTypes.func.isRequired,
  labelButton: PropTypes.string,
};

GoogleLoginButton.defaultProps = {
  focusCreateAccountTab: undefined,
  isLoading: false,
  labelButton: 'Entrar com o Google',
};
